import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4ccc94bb&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccc94bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2025/meiyeJinHuo/meiyeJinHuoAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ccc94bb')) {
      api.createRecord('4ccc94bb', component.options)
    } else {
      api.reload('4ccc94bb', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4ccc94bb&scoped=true&", function () {
      api.rerender('4ccc94bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/finance/remittance/index.vue"
export default component.exports